import CONFIG from './config'

/**
 * 多租户公开站：URL 第一段是用户名（/jopus/…），没有或是保留字则视为根路径（站点列表页）。
 * 与服务端 users.ts 的 USERNAME_RE / RESERVED_USERNAMES 保持一致。
 */
const RESERVED = new Set([
    'admin', 'api', 'uploads', 'healthz', 'post', 'notes', 'activity', 'chat', '404', 'static', 'sites', 'u',
    'assets', 'manifest', 'favicon', 'robots', 'well-known', 'index', 'login', 'logout', 'settings',
])
const USERNAME_RE = /^[a-z0-9][a-z0-9_-]{1,31}$/i

let tenant

/** 当前站点的用户名；根路径返回 null。整个页面生命周期内不变（换用户是整页导航） */
export const getTenant = () => {
    if (tenant !== undefined) return tenant
    const seg = (window.location.pathname.split('/')[1] || '')
    tenant = USERNAME_RE.test(seg) && !RESERVED.has(seg.toLowerCase()) ? seg : null
    return tenant
}

/** react-router basename：/<username> */
export const basename = () => '/' + (getTenant() || '')

/** 该站点的公开 API 前缀：<apiBase>/api/u/<username> */
export const apiPrefix = () => (CONFIG.apiBase || '') + '/api/u/' + getTenant()

/** 对外分享用的绝对地址（带用户名前缀） */
export const publicUrl = (path) => window.location.origin + basename() + path

/** 站内相对资源（如站点设置里的 /uploads/… logo）→ 可加载地址：生产同域原样返回，dev 分域时带上 apiBase */
export function assetUrl(u) {
    if (!u) return u
    return u.startsWith('/') ? (CONFIG.apiBase || '') + u : u
}
